import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { partnersAPI } from '@/providers/apis/partners/partners';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { lookupAPI } from '@/providers/apis/lookup/lookup';
import { facetsAPI } from '@/providers/apis/facets/facets';
import { FacetsFilterKeyModel } from '@/models/facets/facets';

export default class LORFacetsEngine {

    // ---------------------------------------------------
    // Properties

    public actionMapping: any = {
        categories: this.fetchCategories.bind(this),
        publishers: this.fetchPartenerList.bind(this),
        products: this.fetchProductList.bind(this),
    };


    // ---------------------------------------------------
    // Actions



    // ---------------------------------------------------
    // Methods

    public fetchCategories() {
        return taxonomyAPI.fetchTaxonomyClassifications().then((categories) => {
            return categories;
        });
    }

    public fetchPartenerList() {
        const params = {
            offset: 0,
            limit: 100,
            registry_type: 'content_registry',
            search_terms: '',
        };
        return learningRegistryAPI.fetchSubscribedToolRegistryList(params).then((contentRegistry: any) => {
            const subscribedTools = contentRegistry.subscribedTools || [];
            const filterByUnique = [...new Map(subscribedTools.map((item: any) => [item.partnerId, item])).values()];
            return filterByUnique;
        });
    }

    public fetchProductList() {
        const params = {
            offset: 0,
            limit: 100,
            registry_type: 'content_registry',
            search_terms: '',
        };
        return learningRegistryAPI.fetchSubscribedToolRegistryList(params).then((contentRegistry: any) => {
            return contentRegistry.subscribedTools;
        });
    }

    public fetchMetadataDetails(filterKey: FacetsFilterKeyModel) {
        if (filterKey.isCustom) {
            return this.fetchCustomFacetMetadata(filterKey.endpointUrl);
        }
        if (filterKey.useLookup) {
            return this.fetchFacetMetaData(filterKey.facetKey);
        }
        return Promise.resolve([]);
    }

    public fetchFacetMetaData(facetKey: string | any) {
        return lookupAPI.readLookupFacetData(facetKey).then((facetData) => {
            return facetData;
        });
    }

    public fetchCustomFacetMetadata(endpointUrl: string) {
        return facetsAPI.fetchCustomMetadata(endpointUrl).then((customMetadata) => {
            return customMetadata;
        });
    }

    public parsePartnerContent(partnerData: any) {
        const partnerListArray = Object.values(partnerData) || [];
        let partersListItems: any = [];
        partnerListArray.forEach((partnerList) => {
            if (Array.isArray(partnerList)) {
                partersListItems = partersListItems.concat(partnerList);
            }
        });
        return partersListItems;
    }

    public getFacetsList(tenantId: string) {
        return facetsAPI.getFacetsList(tenantId).then((facetItems) => {
            return facetItems;
        });
    }

    public createFacetsList(payload: any, tenantId: string) {
        const params = this.buildFacetPayload(payload, tenantId);
        return facetsAPI.createFacets(params);
    }

    private buildFacetPayload(payload: any, tenantId: string) {
        const keysList = Object.keys(payload);
        const requestPayload: any = [];
        keysList.forEach((keyName) => {
            const facetItem = payload[keyName];
            const items = facetItem.items;
            const filterKey = facetItem.filterKey;
            const selectedItems = facetItem.selectedItems;
            const payloadObj = {
                options: !facetItem.isApiData ? items : [],
                selectedOptions: selectedItems,
                filterKey,
                labelKey: facetItem.name,
                isEditable: facetItem.isEditable,
                isSelected: facetItem.isSelected,
            };
            requestPayload.push(payloadObj);
        });
        const facetPayload: any = {
            facets: requestPayload,
        };
        if (tenantId) {
            facetPayload.tenantId = tenantId;
        }
        return facetPayload;
    }

}
